export default __webpack_public_path__ + "static/19_9-d26ed6571bfe66725928104b5007cb28.png";